
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profileSetting",
      function () {
        return require("private-next-pages/profileSetting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profileSetting"])
      });
    }
  